<template>
  <div>
    <stepheader :step="step" />
    <div
      id="wizard2-p-0"
      role="tabpanel"
      aria-labelledby="wizard2-h-0"
      class="body current"
      aria-hidden="false"
      style=""
    >
      <div class="row">
        <div class="col-12 text-center">
          <div v-if="ticket.ritornoInGaranzia">
            <span> Apri un ticket in funzione della garanzia per l'ultimo danno? </span>
            <div class="row mt-5">
                <div class="col">
                  <button class="btn btn-block btn-lg btn-outline-primary text-center p-5"  @click="siGaranzia()">
                      <i class="fa-2x fa fa-check"></i>
                      <br/>
                      SI
                  </button>             
                </div>
                <div class="col">
                  <button class="btn btn-block btn-lg btn-outline-primary text-center p-5"  @click="noGaranzia()">
                      <i class="fa-2x fa fa-times"></i>               
                      <br/>
                      NO
                  </button>
                  
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "checkgaranzia",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  components: {},
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
    fireaction: function (action, nextstep) {
      switch (action) {
        default:
          this.$emit("goto", nextstep);
          break;
      }
    },
    siGaranzia: function () {
      var nextstep = this.step.buttons.filter(
        (x) => x.action == "ingaranzia"
      )[0];
      this.$emit("goto", nextstep.nextstep);
    },
    noGaranzia: function () {
      this.ticket.ritornoInGaranzia = false;
      var nextstep = this.step.buttons.filter(
        (x) => x.action == "noningaranzia"
      )[0];
      this.$emit("goto", nextstep.nextstep);
    },
    loaddata: function () {  
      console.log(`ritorno in garanzia = ${this.ticket.ritornoInGaranzia}`);
      if (this.ticket.ritornoInGaranzia) {
          var nextstep = this.step.buttons.filter(
            (x) => x.action == "ingaranzia"
          )[0];
          //this.$emit("goto", nextstep.nextstep);
        } else {
          var nextstep = this.step.buttons.filter(
            (x) => x.action == "noningaranzia"
          )[0];
          this.$emit("goto", nextstep.nextstep);
        }     
    },
  },
};
</script>